document.addEventListener('DOMContentLoaded', function () {

  // qty
  var qc = document.getElementById('qc');
  var qiBtn = document.getElementById('qi');
  var qdBtn = document.getElementById('qd');
  var n = 1;
  var MAX_QTY = 10; // <-- yahan apna actual max/stock limit daal do

  if (qc && qiBtn && qdBtn) {
    qiBtn.onclick = function () {
      if (n < MAX_QTY) { n++; qc.textContent = n; }
    };
    qdBtn.onclick = function () {
      if (n > 1) { n--; qc.textContent = n; }
    };
  }

  // bundle select + price sync
  function money(v) { return 'Rs. ' + Number(v).toLocaleString('en-IN'); }

  var curPrice = document.getElementById('curPrice');
  var mrpPrice = document.getElementById('mrpPrice');
  var savePill = document.getElementById('savePill');
  var stickyPrice = document.getElementById('stickyPrice');

  document.querySelectorAll('.bundle').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.bundle').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');

      var p = b.dataset.price, m = b.dataset.mrp, s = b.dataset.save;
      if (curPrice) curPrice.textContent = money(p);
      if (mrpPrice) mrpPrice.textContent = money(m);
      if (savePill) savePill.textContent = 'Save ' + money(s);
      if (stickyPrice) stickyPrice.textContent = money(p);

      // qty reset on bundle change (optional, uncomment if needed)
      // n = 1; if (qc) qc.textContent = n;
    });
  });

  // accordion
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var a = q.nextElementSibling, sp = q.querySelector('span');
      document.querySelectorAll('.faq-a').forEach(function (p) {
        if (p !== a) {
          p.style.maxHeight = null;
          var prevSpan = p.previousElementSibling.querySelector('span');
          if (prevSpan) prevSpan.textContent = '+';
        }
      });
      if (a.style.maxHeight) {
        a.style.maxHeight = null;
        sp.textContent = '+';
      } else {
        a.style.maxHeight = a.scrollHeight + 'px';
        sp.textContent = '×';
      }
    });
  });

  // cert modal
  var cm = document.getElementById('certModal');
  var certOpen = document.getElementById('certOpen');
  var certClose = document.getElementById('certClose');
  if (cm && certOpen && certClose) {
    certOpen.onclick = function () { cm.classList.add('show'); };
    certClose.onclick = function () { cm.classList.remove('show'); };
    cm.onclick = function (e) { if (e.target === cm) cm.classList.remove('show'); };
  }

  // sticky atc on scroll
  var sticky = document.getElementById('stickyAtc');
  var buybox = document.querySelector('.buybox');
  if (sticky && buybox) {
    window.addEventListener('scroll', function () {
      var r = buybox.getBoundingClientRect();
      if (r.bottom < 120) sticky.classList.add('show');
      else sticky.classList.remove('show');
    });
  }

  // drawer
  var ov = document.getElementById('ov');
  var dr = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  var dclose = document.getElementById('dclose');

  if (ov && dr && burger && dclose) {
    burger.onclick = function () { dr.classList.add('show'); ov.classList.add('show'); };
    function closeDr() { dr.classList.remove('show'); ov.classList.remove('show'); }
    dclose.onclick = closeDr;
    ov.onclick = closeDr;
    document.querySelectorAll('.drawer a').forEach(function (a) { a.addEventListener('click', closeDr); });
  }

});